<ng-container *ngIf="!errorOccured; else modifiable">
	<div>
		<span translate>
			quality.issues.draft.saved.successfully
		</span>
	</div>
	<div class="draft-follow-up">
		<span class="draft-follow-up-text" translate>
			quality.issues.draft.edit
		</span>
	</div>
</ng-container>
<ng-template #modifiable>
	<div>
		<span class="claim-submit-error-text" translate>
			quality.issue.save.failed
		</span>
	</div>
	<div class="claim-submit-error">
		<span class="claim-submit-error-text" translate>
			quality.issues.save.failed.message
		</span>
	</div>
</ng-template>